/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Section_PersonInputs */

const en_clients_section_person = /** @type {(inputs: Clients_Section_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Person`)
};

const pt_br2_clients_section_person = /** @type {(inputs: Clients_Section_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pessoa`)
};

/**
* | output |
* | --- |
* | "Person" |
*
* @param {Clients_Section_PersonInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_section_person = /** @type {((inputs?: Clients_Section_PersonInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Section_PersonInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_section_person(inputs)
	return pt_br2_clients_section_person(inputs)
});